import type { IProvider } from './provider-types';

export const noneProvider: IProvider = {
  id: 'none',
  initialize: () => Promise.resolve(),
  async authenticate() {
    return;
  },
  async getAuthHeaders() {
    return {};
  },
  async getUserInfo() {
    return { email: '' };
  },
  openWidget: () => {},
};
